import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218cba9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Events", -1))
const _hoisted_3 = {
  key: 1,
  class: "colored-bg full-height"
}
const _hoisted_4 = {
  key: 0,
  class: "container",
  style: {"min-height":"300px"}
}
const _hoisted_5 = { class: "flex-desktop back-title-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Events", -1))

import {
  IonIcon,
  IonPage,
  IonContent,
  IonAlert,
  IonItem,
  IonLabel,
  IonLoading,
} from "@ionic/vue";

import { settings, trash, arrowBack } from "ionicons/icons";
import { deleteEvent } from "@/api/events";
import { handleError } from "@/views";
import router from "@/router";
import { reactive, watch } from "vue";
import { useToasters } from "@/composition/toasters";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";

interface IManagebleEvent {
  id: number;
  name: string;
  user_can_exclude: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageEvents',
  setup(__props) {

const { isMobile } = useWindowWidth();

const toasters = useToasters();
const userStore = useUserStore();

const state = reactive({
  loading: true,
  alertEvent: false,
  alertEventManager: false,
  currentEventEdition: 0,
  events: [] as IManagebleEvent[],
});

const openDialogDeleteEvent = (edit_type: string, id: number) => {
  if (edit_type === "event") {
    state.currentEventEdition = id;
    state.alertEvent = true;
  } else {
    state.alertEventManager = true;
  }
};

const editEvent = (id: number) => {
  router.push(`/event/${id}/settings`);
};

watch(
  () => userStore.links.owns.ids,
  (event_ids) => {
    if (event_ids) {
      userStore.related.events.forEach((event) => {
        state.events.push({
          id: event.id,
          user_can_exclude: event_ids.includes(event.id),
          name: event.name,
        });
      });
    }
    state.loading = false;
  }
);

const deleteButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      state.alertEvent = false;
      state.currentEventEdition = 0;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      state.alertEvent = false;
      deleteEventById(state.currentEventEdition);
    },
  },
];

const deleteEventById = (event_id: number) => {
  state.loading = true;
  deleteEvent(event_id)
    .then(() => {
      state.loading = false;
      router.push("/home");
      toasters.addSuccess("Event deleted successfully");
      userStore.fetchMe();
    })
    .catch((err) => {
      state.loading = false;
      if (err.response.data && err.response.data[0]) {
        toasters.addError(err.response.data[0]);
      } else {
        handleError(err);
      }
    });
};

return (_ctx: any,_cache: any) => {
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              (state.events.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.events, (event, i) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: `event-${event.id}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("b", null, "#" + _toDisplayString(i + 1), 1),
                            _createTextVNode(" ")
                          ]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(event.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(settings),
                            size: "small",
                            slot: "end",
                            onClick: ($event: any) => (editEvent(event.id))
                          }, null, 8, ["icon", "onClick"]),
                          (event.user_can_exclude)
                            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 0,
                                icon: _unref(trash),
                                size: "small",
                                slot: "end",
                                color: "danger",
                                onClick: ($event: any) => (openDialogDeleteEvent('event', event.id))
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(IonAlert), {
                            isOpen: state.alertEvent,
                            buttons: deleteButtons,
                            header: "Are you sure?",
                            message: "This will permanently delete your event."
                          }, null, 8, ["isOpen"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonLoading), {
                "is-open": state.loading,
                message: "Please wait..."
              }, null, 8, ["is-open"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (state.events.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (!_unref(isMobile))
                      ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                          key: 0,
                          class: "fab-manage-events",
                          color: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_6
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.events, (event, i) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      key: `event-${event.id}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", null, "#" + _toDisplayString(i + 1), 1),
                          _createTextVNode(" ")
                        ]),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(event.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(settings),
                          size: "small",
                          slot: "end",
                          onClick: ($event: any) => (editEvent(event.id))
                        }, null, 8, ["icon", "onClick"]),
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(trash),
                          size: "small",
                          slot: "end",
                          color: "danger",
                          onClick: ($event: any) => (openDialogDeleteEvent('event', event.id))
                        }, null, 8, ["icon", "onClick"]),
                        _createVNode(_unref(IonAlert), {
                          isOpen: state.alertEvent,
                          buttons: deleteButtons,
                          header: "Are you sure?",
                          message: "This will permanently delete your event."
                        }, null, 8, ["isOpen"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}
}

})